import * as actionTypes from '../constants/actionTypes';

const initialState = {
    isRegister: false,
    isFetching: false,
    errorCode: null,
    errors: []
};

export function registration(state = initialState, action) {
    switch (action.type) {

        case actionTypes.REGISTER_USER:
            return {
                ...state,
                isRegister: true,
                errors: []
            };

        case actionTypes.CANCEL_REGISTRATION:
            return {
                ...state,
                isRegister: false
            };

        case actionTypes.REGISTRATION_REQUEST:
            return {
                ...state,
                isFetching: true,
                errorCode: null,
                errors: []
            };

        case actionTypes.REGISTRATION_SUCCESS:
            return {
                ...state,
                isFetching: false
            };

        case actionTypes.REGISTRATION_FAILED:
            return {
                ...state,
                isFetching: false,
                errors: action.errors
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/registration.js